module.exports = __webpack_public_path__ + "static/assets/8f531cd80e1aa712fdff13a69c9c62e2.svg";